module.exports = Package["meteor"];


//////////////////
// WEBPACK FOOTER
// external "Package[\"meteor\"]"
// module id = 131
// module chunks = 1